import React, { ReactNode } from "react";
import {
  Divider,
  Grid,
} from "@mui/material";

export default function InstanceContactTable ({
  title,
  headers,
  tableData
}: {
  title: string,
  headers: ReactNode,
  tableData: ReactNode
}) {
  return (
    <>
      <Grid item xs={12}> 
        <Divider orientation="horizontal" flexItem/>
      </Grid>
      <Grid item xs={2} sx={{ fontSize: "125%" }}>
        {title}
      </Grid>
      <Grid item xs={10}>
        <Grid container spacing={1}>
          {headers}
          {tableData}
        </Grid>
      </Grid>
    </>
  );
}